module.exports = __webpack_public_path__ + "img/fruit-apricots-350x184.3f1d0e5f.jpg";